import { Capacitor } from "@capacitor/core";
import { SocialLogin } from "@capgo/capacitor-social-login";
import React, { useEffect, useRef, useState } from "react";

import theme from "@/theme";

import { SocialLoginButton } from "./SocialLoginButton";

// TODO: Google クライアントID は公開して問題のない値だが、可能ならenvなどにまとめる方が望ましい
// ただし値の設定方法の違いにより、Webや実機で読み込める/読み込めないの差分が発生し得るため注意
const GOOGLE_OAUTH2_LOGIN_WEB_CLIENT_ID = "200340579193-glfqege5llcphb88cdrbneenumr7ccc3.apps.googleusercontent.com";
// Android側のクライアントIDはGoogle Cloud Console 側で設定するのみだが、参考までに記載
// const GOOGLE_OAUTH2_LOGIN_ANDROID_CLIENT_ID = "200340579193-gto7melj21k3l1us2v2v5maesmgljm64.apps.googleusercontent.com";
const GOOGLE_OAUTH2_LOGIN_IOS_CLIENT_ID = "200340579193-3jln8ehq9rtl5q3593g2epul62e76njb.apps.googleusercontent.com";

const GoogleLoginButton = ({ onSuccess, onError, v2 = false, disabled = false, labelSize = undefined }) => {
  const [pending, setPending] = useState(false);
  const busy = useRef(false);
  useEffect(() => {
    const initSocialLogin = async () => {
      if (Capacitor.isNativePlatform()) {
        if (Capacitor.getPlatform() === "ios") {
          await SocialLogin.initialize({
            google: {
              iOSClientId: GOOGLE_OAUTH2_LOGIN_IOS_CLIENT_ID,
            },
          });
        } else {
          await SocialLogin.initialize({
            google: {
              webClientId: GOOGLE_OAUTH2_LOGIN_WEB_CLIENT_ID,
            },
          });
        }
      } else {
        await SocialLogin.initialize({
          google: {
            webClientId: GOOGLE_OAUTH2_LOGIN_WEB_CLIENT_ID,
          },
        });
      }
    };
    initSocialLogin();
  }, []);

  const handleError = () => {
    onError?.();
  };

  const handleNativeLogin = async () => {
    if (busy.current || disabled) return;
    busy.current = true;
    setPending(true);
    try {
      const response = await SocialLogin.login({
        provider: "google",
        options: {},
      });
      const result = response.result;
      await onSuccess(result);
    } catch (err) {
      handleError();
    } finally {
      busy.current = false;
      setPending(false);
    }
  };

  if (v2)
    return (
      <SocialLoginButton
        provider="google"
        labelSize={labelSize}
        disabled={disabled || pending}
        onClick={handleNativeLogin}
      />
    );

  const buttonStyle: React.CSSProperties = {
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #747775",
    borderRadius: 4,
    boxSizing: "border-box",
    color: theme.palette.text.primary,
    cursor: "pointer",
    fontFamily: "'Roboto', Arial, sans-serif",
    fontSize: labelSize ?? 14,
    height: 40,
    padding: "0 12px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: 300,
    transition: "all 0.2s ease",
  };

  const iconStyle: React.CSSProperties = {
    width: 20,
    height: 20,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: 12,
  };

  const textStyle: React.CSSProperties = {
    fontWeight: 500,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  };

  return (
    <button type="button" disabled={disabled || pending} style={buttonStyle} onClick={handleNativeLogin}>
      <div style={iconStyle}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" style={{ width: 20, height: 20 }}>
          <path
            fill="#EA4335"
            d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
          />
          <path
            fill="#4285F4"
            d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
          />
          <path
            fill="#FBBC05"
            d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
          />
          <path
            fill="#34A853"
            d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
          />
          <path fill="none" d="M0 0h48v48H0z" />
        </svg>
      </div>
      <span style={textStyle}>Googleでログイン</span>
    </button>
  );
};

export default GoogleLoginButton;
